import CometMarquee from 'comet-marquee';

const clientsMarqueeInstances = new WeakMap();
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const restoreStyle = (element, style) => {
  if (style === null) {
    element.removeAttribute('style');
  } else {
    element.setAttribute('style', style);
  }
};

const initClientsMarquees = (scope = document) => {
  scope.querySelectorAll('.clients-marquee').forEach((element) => {
    if (reducedMotion.matches) {
      const state = clientsMarqueeInstances.get(element);

      if (state) {
        state.marquee.destroy();
        const content = state.content;
        content.querySelectorAll('.comet-marquee-clone').forEach((clone) => clone.remove());
        element.classList.remove('is-init-comet-marquee');
        restoreStyle(element, state.containerStyle);
        restoreStyle(content, state.contentStyle);
        clientsMarqueeInstances.delete(element);
      }
      return;
    }

    if (clientsMarqueeInstances.has(element)) {
      return;
    }

    const content = element.querySelector('.comet-marquee-content');
    const itemCount = content?.querySelectorAll('.comet-marquee-item:not(.comet-marquee-clone)').length || 0;

    if (!itemCount) {
      return;
    }

    const isDesktop = window.innerWidth >= 1033;
    const containerStyle = element.getAttribute('style');
    const contentStyle = content.getAttribute('style');
    const marquee = new CometMarquee(element, {
      speed: 40,
      pauseOnHover: true,
      initialShift: isDesktop,
      pauseOnInvisible: true,
      syncPause: false,
      repeatCount: 5,
      forceAnimation: itemCount > 2 || isDesktop,
      forceAnimationWidth: isDesktop ? 3 : 2,
      fullWidth: isDesktop,
    });

    clientsMarqueeInstances.set(element, { marquee, content, containerStyle, contentStyle });
  });
};

initClientsMarquees();
reducedMotion.addEventListener('change', () => initClientsMarquees());
